import * as React from 'react';
import {Incident} from '../../../../store/incidents/commonTypes';
import {Audit} from '../../../../store/projects/commonTypes';
import {formatDateTime} from '../../../../utils/utils';
import {User} from 'oidc-client';
import SecurableDownloadLink from "../../../application/SecurableDownloadLink";
import {Download} from "@mui/icons-material";

export interface AuditDetailsProps {
    audit: Audit;
    user: User;
    showError: (error) => void;
}

export default class AuditDetails extends React.Component<AuditDetailsProps> {

    public render() {
        return (
            <React.Fragment>
                <div className="details">
                    <div className="row">
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Status</span>
                            </div>
                            <div>
                                <span className="data-value">{this.props.audit.status}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Opprettet</span>
                            </div>
                            <div>
                                <span className="data-value">{formatDateTime(this.props.audit.created)}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-3 mb-4">
                            <div>
                                <span className="label">Scoringsrapport</span>
                            </div>
                            <div>
                                <span className="data-value"><SecurableDownloadLink user={this.props.user}
                                                                                    showError={error => this.props.showError(error)}
                                                                                    path={`/api/certification/audits/${this.props.audit.id}/scoringreport`}><Download/> Last ned</SecurableDownloadLink></span>
                            </div>
                        </div>
                        {(this.props.audit.qaReportInternalLink) && (
                            <div className="col-sm-12 col-md-3 mb-4">
                                <div>
                                    <span className="label">QA-Rapport</span>
                                </div>
                                <div>
                                    <span className="data-value"><SecurableDownloadLink user={this.props.user}
                                                                                        showError={error => this.props.showError(error)}
                                                                                        path={`/api/certification/audits/${this.props.audit.id}/qareport`}><Download/> Last ned</SecurableDownloadLink></span>
                                </div>
                            </div>
                        )}
                        {this.props.audit.comments && (
                            <div className="col-sm-12 mb-4">
                                <div>
                                    <span className="label">Oppsummering</span>
                                </div>
                                <div>
                                    <span className="data-value">{this.props.audit.comments}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}